import getCurrencySymbol from 'currency-symbol-map';

export const isCurrencyValid = (currency: string): boolean =>
  getCurrencySymbol(currency) !== undefined;

export { getCurrencySymbol };
